var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShow)?_c('el-tooltip',{attrs:{"content":`${_vm.content}: ${_vm.scope.row[_vm.fields] || '⏤'}`,"placement":"bottom","effect":"light"}},[_c('div',{staticClass:"triangle-topright"})]):_vm._e(),_c('vxe-input',_vm._g(_vm._b({ref:"vxeInput",staticClass:"vxe-button-edit-render",on:{"focus":_vm.focus,"keyup":_vm.keyup},model:{value:(_vm.row[_vm.column.property]),callback:function ($$v) {_vm.$set(_vm.row, _vm.column.property, (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"row[column.property]"}},'vxe-input',_vm.vxeInputPropsProxy,false),{
      ..._vm.otherEvent,
      change: _vm.onChange,
      blur: _vm.onBlur
    }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }